var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 7.96053C7.875 5.63512 9.83375 3.75 12.25 3.75C14.6662 3.75 16.625 5.63512 16.625 7.96053C16.625 10.2859 14.6662 12.1711 12.25 12.1711C9.83375 12.1711 7.875 10.2859 7.875 7.96053ZM12.25 10.4868C13.6997 10.4868 14.875 9.35577 14.875 7.96053C14.875 6.56528 13.6997 5.43421 12.25 5.43421C10.8003 5.43421 9.625 6.56528 9.625 7.96053C9.625 9.35577 10.8003 10.4868 12.25 10.4868Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30025 14.9863C5.9875 16.2497 5.25 17.9633 5.25 19.75H7C7 18.41 7.55312 17.1248 8.53769 16.1772C9.52226 15.2297 10.8576 14.6974 12.25 14.6974C13.6424 14.6974 14.9777 15.2297 15.9623 16.1772C16.9469 17.1248 17.5 18.41 17.5 19.75H19.25C19.25 17.9633 18.5125 16.2497 17.1997 14.9863C15.887 13.7229 14.1065 13.0132 12.25 13.0132C10.3935 13.0132 8.61301 13.7229 7.30025 14.9863Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolIcon);
export default __webpack_public_path__ + "static/media/coolIcon.d793adb1.svg";
export { ForwardRef as ReactComponent };